// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3cxfk","question":"Question_question__1FYBK","description":"Question_description__23SFx"};